module.exports = {
    INSURANCE: 'INSURANCE',
    SERVICE_OPTION: 'SERVICE_OPTION',
    FARE_RULE: 'FARE_RULE',
    SEATS: 'SEATS',
    BOARDING_OPTIONS: 'BOARDING_OPTIONS',
    BAGGAGE: 'BAGGAGE',
    FAST_TRACK: 'FAST_TRACK',
};
